<script setup lang="ts">
const props = defineProps<{ bg: string }>()

const footerNavigation = [
  { name: "About XYPN", url: "https://www.xyplanningnetwork.com/" },
  { name: "Privacy Policy", url: "/privacy-policy" },
  { name: "Terms", url: "/terms" },
  { name: "Help Desk", url: "https://xy-archive.helpscoutdocs.com/" },
]
</script>

<template>
  <footer :class="props.bg">
    <div class="mx-auto max-w-7xl overflow-hidden px-6 py-6 sm:py-10 lg:px-8">
      <nav
        class="-mb-6 columns-2 sm:flex sm:justify-center sm:space-x-12"
        aria-label="Footer"
      >
        <div
          v-for="item in footerNavigation"
          :key="item.name"
          class="pb-6 z-10"
        >
          <a
            :href="item.url"
            class="text-sm font-medium text-gray-600 hover:text-gray-900 focus:outline-none focus:text-gray-900 transition duration-150 ease-in-out"
            >{{ item.name }}</a
          >
        </div>
      </nav>
    </div>
  </footer>
</template>
